import { useState, useEffect, useCallback } from 'react';
import API from '../api/axios';

const LIMIT = 10;

const style = document.createElement('style');
style.textContent = `
.sm-container {
  max-width: 1200px; margin: 0 auto; padding: 2rem 1.5rem;
}
.sm-header {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  border-radius: 1rem; padding: 2rem 2.5rem; margin-bottom: 2rem;
  display: flex; justify-content: space-between; align-items: center;
  box-shadow: 0 4px 24px rgba(99, 102, 241, 0.25);
}
.sm-header h1 { color: #fff; font-size: 1.75rem; font-weight: 700; margin: 0 0 0.25rem; }
.sm-header p { color: rgba(255,255,255,0.8); font-size: 0.9rem; margin: 0; }
.sm-header .btn-add { background: rgba(255,255,255,0.2); border: 1px solid rgba(255,255,255,0.3); color: #fff; padding: 0.6rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-size: 0.9rem; font-weight: 600; transition: all 0.2s; backdrop-filter: blur(4px); }
.sm-header .btn-add:hover { background: rgba(255,255,255,0.3); }
.sm-card { background: #fff; border-radius: 0.75rem; box-shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04); overflow: hidden; }
.sm-card.dark { background: #1e293b; }
.sm-tabs { display: flex; border-bottom: 1px solid #e2e8f0; padding: 0 1.5rem; }
.sm-tab { padding: 1rem 1.5rem; border: none; background: none; cursor: pointer; font-size: 0.9rem; font-weight: 500; color: #64748b; position: relative; transition: color 0.2s; }
.sm-tab:hover { color: #6366f1; }
.sm-tab.active { color: #6366f1; font-weight: 600; }
.sm-tab.active::after { content: ''; position: absolute; bottom: -1px; left: 0; right: 0; height: 2px; background: #6366f1; border-radius: 2px 2px 0 0; }
.sm-stats { display: flex; gap: 1rem; padding: 1.5rem; }
.sm-stat { background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 0.5rem; padding: 1rem 1.25rem; flex: 1; }
.sm-stat-value { font-size: 1.5rem; font-weight: 700; color: #1e293b; }
.sm-stat-label { font-size: 0.8rem; color: #64748b; margin-top: 0.25rem; }
.sm-table-wrap { overflow-x: auto; padding: 0 1.5rem 1.5rem; }
.sm-table { width: 100%; border-collapse: collapse; }
.sm-table th { text-align: left; padding: 0.75rem 1rem; font-size: 0.8rem; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; border-bottom: 2px solid #e2e8f0; }
.sm-table td { padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9; font-size: 0.9rem; color: #1e293b; }
.sm-table tbody tr:hover { background: #f8fafc; }
.sm-table tbody tr:last-child td { border-bottom: none; }
.sm-code { background: #eef2ff; color: #6366f1; padding: 0.2rem 0.5rem; border-radius: 0.25rem; font-size: 0.8rem; font-weight: 600; font-family: monospace; }
.sm-badge { display: inline-flex; align-items: center; gap: 0.25rem; background: #f0fdf4; color: #16a34a; padding: 0.25rem 0.65rem; border-radius: 1rem; font-size: 0.75rem; font-weight: 600; }
.sm-pagination { display: flex; align-items: center; justify-content: center; gap: 0.75rem; padding: 1rem; border-top: 1px solid #e2e8f0; }
.sm-page-btn { padding: 0.4rem 0.9rem; border: 1px solid #e2e8f0; border-radius: 0.375rem; background: #fff; cursor: pointer; font-size: 0.85rem; color: #475569; transition: all 0.15s; }
.sm-page-btn:hover:not(:disabled) { border-color: #6366f1; color: #6366f1; }
.sm-page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.sm-page-info { font-size: 0.85rem; color: #94a3b8; }
.sm-settings { padding: 2rem; }
.sm-settings-title { font-size: 1.1rem; font-weight: 600; color: #1e293b; margin: 0 0 0.25rem; }
.sm-settings-desc { font-size: 0.85rem; color: #64748b; margin: 0 0 1.5rem; }
.sm-toggle-wrap { display: flex; flex-direction: column; gap: 1rem; max-width: 500px; }
.sm-toggle { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border: 1px solid #e2e8f0; border-radius: 0.75rem; transition: all 0.2s; cursor: pointer; }
.sm-toggle:hover { border-color: #c7d2fe; background: #f8fafc; }
.sm-toggle-label { font-weight: 500; color: #1e293b; font-size: 0.9rem; }
.sm-toggle-desc { font-size: 0.8rem; color: #94a3b8; margin-top: 0.15rem; }
.sm-switch { position: relative; width: 44px; height: 24px; flex-shrink: 0; }
.sm-switch input { opacity: 0; width: 0; height: 0; }
.sm-slider { position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background: #cbd5e1; border-radius: 24px; transition: 0.3s; }
.sm-slider::before { content: ''; position: absolute; height: 18px; width: 18px; left: 3px; bottom: 3px; background: #fff; border-radius: 50%; transition: 0.3s; }
.sm-switch input:checked + .sm-slider { background: #6366f1; }
.sm-switch input:checked + .sm-slider::before { transform: translateX(20px); }
.sm-switch input:disabled + .sm-slider { opacity: 0.5; cursor: not-allowed; }
.sm-empty { text-align: center; padding: 3rem 1.5rem; }
.sm-empty p { color: #94a3b8; font-size: 0.9rem; }
`;
document.head.appendChild(style);

const SubjectManagement = () => {
  const [activeTab, setActiveTab] = useState('subjects');
  const [universitySubjects, setUniversitySubjects] = useState([]);
  const [showCreateSubject, setShowCreateSubject] = useState(false);
  const [newSubject, setNewSubject] = useState({ subject_name: '', subject_code: '', description: '' });
  const [page, setPage]         = useState(1);
  const [total, setTotal]       = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');

  const [settings, setSettings] = useState(null);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchUniversitySubjects = useCallback(async (p) => {
    try {
      const { data } = await API.get(`/faculty-certification/university-subjects?page=${p}&limit=${LIMIT}`);
      if (data.success) {
        setUniversitySubjects(data.university_subjects || []);
        setTotal(data.total || 0);
        setTotalPages(data.totalPages || 1);
      }
    } catch (err) {
      console.error('Failed to fetch university subjects:', err);
    }
  }, []);

  const totalFaculty = universitySubjects.reduce((sum, s) => sum + (s.assigned_count || 0), 0);

  useEffect(() => {
    fetchUniversitySubjects(page).finally(() => setLoading(false));
  }, [page, fetchUniversitySubjects]);

  useEffect(() => {
    if (activeTab === 'settings') {
      fetchSettings();
    }
  }, [activeTab]);

  const fetchSettings = async () => {
    setSettingsLoading(true);
    try {
      const { data } = await API.get('/subjects/assignment-settings');
      if (data.success) {
        setSettings(data.settings);
      }
    } catch (err) {
      console.error('Failed to fetch settings:', err);
    } finally {
      setSettingsLoading(false);
    }
  };

  const handleToggle = async (key, value) => {
    const updated = { ...settings, [key]: value };
    setSettings(updated);
    setSaving(true);
    try {
      await API.put('/subjects/assignment-settings', { [key]: value });
    } catch (err) {
      setSettings({ ...settings });
      console.error('Failed to update setting:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCreateSubject = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!newSubject.subject_name || !newSubject.subject_code) {
      setError('Please fill in subject name and code');
      return;
    }

    try {
      const { data } = await API.post('/faculty-certification/create-subject-for-university', {
        subject_name: newSubject.subject_name,
        subject_code: newSubject.subject_code,
        description: newSubject.description
      });

      if (data.success) {
        setSuccess(`Subject "${data.subject_name}" created successfully!`);
        setNewSubject({ subject_name: '', subject_code: '', description: '' });
        setShowCreateSubject(false);
        fetchUniversitySubjects(page);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create subject');
    }
  };

  if (loading) {
    return <div className="loading"><div className="spinner"></div></div>;
  }

  return (
    <div className="sm-container">
      <div className="sm-header">
        <div>
          <h1>Subject Management</h1>
          <p>Manage university-level subjects and assignment settings</p>
        </div>
        <button className="btn-add" onClick={() => setShowCreateSubject(true)}>
          + Add Subject
        </button>
      </div>

      {error && <div className="form-error">{error}</div>}
      {success && <div className="form-success">{success}</div>}

      <div className="sm-card">
        <div className="sm-tabs">
          <button className={`sm-tab ${activeTab === 'subjects' ? 'active' : ''}`} onClick={() => setActiveTab('subjects')}>
            University Subjects
          </button>
          <button className={`sm-tab ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => setActiveTab('settings')}>
            Subject Settings
          </button>
        </div>

        {activeTab === 'subjects' && (
          <>
            {universitySubjects.length > 0 && (
              <div className="sm-stats">
                <div className="sm-stat">
                  <div className="sm-stat-value">{total}</div>
                  <div className="sm-stat-label">Total Subjects</div>
                </div>
                <div className="sm-stat">
                  <div className="sm-stat-value">{totalFaculty}</div>
                  <div className="sm-stat-label">Assigned Faculty</div>
                </div>
                <div className="sm-stat">
                  <div className="sm-stat-value">{Math.round(total > 0 ? totalFaculty / total : 0)}</div>
                  <div className="sm-stat-label">Avg Faculty / Subject</div>
                </div>
              </div>
            )}

            {showCreateSubject && (
              <div className="modal-overlay" onClick={() => setShowCreateSubject(false)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <h3>Create New Subject</h3>
                  <form onSubmit={handleCreateSubject}>
                    <div className="form-group">
                      <label className="form-label">Subject Name *</label>
                      <input
                        type="text"
                        className="form-input"
                        value={newSubject.subject_name}
                        onChange={(e) => setNewSubject({ ...newSubject, subject_name: e.target.value })}
                        placeholder="e.g., Advanced Mathematics"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Subject Code *</label>
                      <input
                        type="text"
                        className="form-input"
                        value={newSubject.subject_code}
                        onChange={(e) => setNewSubject({ ...newSubject, subject_code: e.target.value })}
                        placeholder="e.g., MATH-401"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-input"
                        value={newSubject.description}
                        onChange={(e) => setNewSubject({ ...newSubject, description: e.target.value })}
                        placeholder="Brief description of the subject"
                        rows="3"
                        style={{ resize: 'vertical', minHeight: '80px' }}
                      />
                    </div>
                    <div className="modal-actions">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowCreateSubject(false)}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        + Add Subject
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            <div className="sm-table-wrap">
              {universitySubjects.length === 0 ? (
                <div className="sm-empty">
                  <p>No subjects added yet. Click "Add Subject" to create one.</p>
                </div>
              ) : (
                <table className="sm-table">
                  <thead>
                    <tr>
                      <th>Subject Name</th>
                      <th>Code</th>
                      <th>Assigned Faculty</th>
                    </tr>
                  </thead>
                  <tbody>
                    {universitySubjects.map(subject => (
                      <tr key={subject.university_subject_id}>
                        <td>
                          <div style={{ fontWeight: 600 }}>{subject.subject_name}</div>
                          {subject.description && (
                            <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginTop: '0.2rem' }}>
                              {subject.description}
                            </div>
                          )}
                        </td>
                        <td><span className="sm-code">{subject.subject_code}</span></td>
                        <td>
                          <span className="sm-badge">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
                            {subject.assigned_count || 0}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {totalPages > 1 && (
              <div className="sm-pagination">
                <button className="sm-page-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Prev</button>
                <span className="sm-page-info">Page {page} of {totalPages}</span>
                <button className="sm-page-btn" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Next</button>
              </div>
            )}
          </>
        )}

        {activeTab === 'settings' && (
          <div className="sm-settings">
            <h3 className="sm-settings-title">Subject Assignment Settings</h3>
            <p className="sm-settings-desc">Configure whether multiple faculty members can be assigned to the same subject</p>
            {settingsLoading ? (
              <div className="loading"><div className="spinner"></div></div>
            ) : !settings ? (
              <p style={{ color: '#94a3b8' }}>Failed to load settings.</p>
            ) : (
              <div className="sm-toggle-wrap">
                <label className="sm-toggle" style={{ opacity: saving ? 0.6 : 1 }}>
                  <div>
                    <div className="sm-toggle-label">Allow college admin to manage these settings</div>
                    <div className="sm-toggle-desc">When disabled, only university admin can configure subject assignment rules</div>
                  </div>
                  <label className="sm-switch" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={settings.college_admin_accessible}
                      onChange={(e) => handleToggle('college_admin_accessible', e.target.checked)}
                      disabled={saving}
                    />
                    <span className="sm-slider"></span>
                  </label>
                </label>
                <label className="sm-toggle" style={{ opacity: saving ? 0.6 : 1 }}>
                  <div>
                    <div className="sm-toggle-label">Allow multiple users per subject</div>
                    <div className="sm-toggle-desc">When disabled, only one SME, Examiner, or Moderator can be assigned per subject</div>
                  </div>
                  <label className="sm-switch" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={settings.allow_multiple_users_per_subject}
                      onChange={(e) => handleToggle('allow_multiple_users_per_subject', e.target.checked)}
                      disabled={saving}
                    />
                    <span className="sm-slider"></span>
                  </label>
                </label>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubjectManagement;
